import { Button, message, Steps } from 'antd';
import axios from 'axios';
import { history } from 'ice';
import React, { useEffect, useState } from 'react';

import client from '../../../../lib/feathers';
import styles from './index.module.scss';
import Template from './template';
import TemplatePreview from './templatePreview';
import TemplateSetting from './templateSetting';
import TemplateSize from './templateSize';

const { Step } = Steps;

const BroadcastList = () => {
  const broadcast = client.service('broadcast');
  const [current, setCurrent] = useState(0);
  // 模板類型
  const [template, setTemplate] = useState('');
  // 模板大小
  const [inputValueOne, setInputValueOne] = useState(50);
  const [inputValueTwo, setInputValueTwo] = useState(50);
  const [inputValueTop, setInputValueTop] = useState(80);
  const [inputValueBottom, setInputValueBottom] = useState(20);
  const [title, setTitle] = useState('');
  const [full, setFull] = useState(false);
  const [uploadPath, setUploadPath] = useState('');
  const [uploadData, setUploadData] = useState(null);
  // 模板內容
  const [addTemplateContent, setAddTemplateContent] = useState([
    { carousel: true, color: '#FFFFFF', size: 0, children: [] },
    { carousel: true, color: '#FFFFFF', size: 0, children: [] },
    { carousel: true, color: '#FFFFFF', size: 0, children: [] },
  ]);
  const [userName, setUserName] = useState('');

  useEffect(() => {
    client.reAuthenticate().then((data) => {
      setUserName(data.user.name);
    });
  }, []);

  const steps = [
    {
      title: '模板樣式',
      description: '請選擇模板樣式',
      content: <Template setTemplate={setTemplate} template={template} />,
    },
    {
      title: '模板大小',
      description: '請設定模板大小',
      content: (
        <TemplateSize
          {...{
            template,
            inputValueOne,
            setInputValueOne,
            inputValueTwo,
            setInputValueTwo,
            inputValueTop,
            setInputValueTop,
            inputValueBottom,
            setInputValueBottom,
            addTemplateContent,
            setAddTemplateContent,
            title,
            setTitle,
            uploadPath,
            setUploadPath,
            uploadData,
            setUploadData,
            full,
            setFull,
          }}
        />
      ),
    },
    {
      title: '內容設定',
      description: '請設定各區塊顯示內容',
      content: (
        <TemplateSetting
          {...{
            template,
            inputValueOne,
            inputValueTwo,
            inputValueTop,
            inputValueBottom,
            addTemplateContent,
            setAddTemplateContent,
          }}
        />
      ),
    },
    {
      title: '預覽',
      description: '預覽內容',
      content: (
        <TemplatePreview
          {...{
            template,
            addTemplateContent,
          }}
        />
      ),
    },
  ];

  const next = () => {
    // 回到頂端
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    if (current === 1 && title === '') {
      message.error('請輸入公播名稱');
      setCurrent(current);
    } else if (current === 0 && template === '') {
      message.error('請選擇模板樣式');
      setCurrent(current);
    } else {
      setCurrent(current + 1);
    }

    // 將大小存入
    if (current === 1) {
      if (template === 'one') {
        addTemplateContent.splice(1, 2);
        addTemplateContent[0].size = 100;
      } else if (template === 'two') {
        addTemplateContent.splice(2, 1);
        addTemplateContent[0].size = inputValueOne;
        addTemplateContent[1].size = inputValueTwo;
      } else if (template === 'three') {
        addTemplateContent.splice(2, 1);
        addTemplateContent[0].size = inputValueTop;
        addTemplateContent[1].size = inputValueBottom;
      } else {
        addTemplateContent[0].size = inputValueOne;
        addTemplateContent[1].size = inputValueTwo;
        addTemplateContent[2].size = inputValueBottom;
      }

      setAddTemplateContent(addTemplateContent.map((x) => ({ ...x })));
    }
  };

  const prev = () => {
    setCurrent(current - 1);
    // 回歸初始值
    if (current === 1) {
      const array = [
        { carousel: true, color: '#FFFFFF', size: 0, children: [] },
        { carousel: true, color: '#FFFFFF', size: 0, children: [] },
        { carousel: true, color: '#FFFFFF', size: 0, children: [] },
      ];
      setAddTemplateContent(array.map((x) => ({ ...x })));
      setTitle('');
    }
  };

  const onSetBroadcast = async () => {
    try {
      let backgroundMusic = null;
      if (uploadData) {
        const body = new FormData();
        body.append('files', uploadData);
        const res = await fetch('/newUploads?type=broadcast', {
          method: 'POST',
          body,
          headers: { authorization: window.localStorage['feathers-jwt'] },
        });
        const { showPath, _id } = (await res.json())[0];
        backgroundMusic = {
          path: showPath,
          name: uploadData.name,
          id: _id,
        };
      }
      const newTextArr = [];
      for (let i = 0; i < addTemplateContent.length; i++) {
        for (let j = 0; j < addTemplateContent[i].children.length; j++) {
          if (
            addTemplateContent[i].children[j].typeContent === 'text' &&
            addTemplateContent[i].children[j].typeContent === 'iframe' &&
            addTemplateContent[i].children[j].checkTextSound
          ) {
            newTextArr.push(addTemplateContent[i].children[j].typeFormat);
          }
        }
      }
      if (newTextArr.length > 0) {
        await axios('/ezcon/api/textToMp3', {
          method: 'POST',
          headers: {
            authorization: window.localStorage['feathers-jwt'],
          },
          data: { text: newTextArr },
        });
      }
      const obj = {
        title,
        backgroundMusic,
        full,
        userName,
        template,
        content: addTemplateContent,
      };
      await broadcast.create(obj);
      message.success('公播建立成功');
      setTimeout(() => {
        history.push('/ezpro/broadcast/broadcastList');
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Steps current={current}>
        {steps.map((item) => (
          <Step
            key={item.title}
            title={item.title}
            description={item.description}
          />
        ))}
      </Steps>
      {current === 2 ? (
        <div className={styles.stepsContent1}>{steps[current].content}</div>
      ) : (
        <div className={styles.stepsContent}>{steps[current].content}</div>
      )}

      <div className={styles.stepsAction}>
        {current < steps.length - 1 && (
          <Button type="primary" onClick={() => next()}>
            下一步
          </Button>
        )}
        {current === steps.length - 1 && (
          <Button type="primary" onClick={() => onSetBroadcast()}>
            送出
          </Button>
        )}
        {current > 0 && (
          <Button style={{ margin: '0 8px' }} onClick={() => prev()}>
            返回
          </Button>
        )}
      </div>
    </>
  );
};

export default BroadcastList;
